// Agregador de rotas — sem instância de router (T123, AD-018).
//
// `src/router/index.ts` cria o router (createRouter) e por isso virava hub de
// import: qualquer módulo que precisasse só das listas de rota (ex.:
// `src/store/layout.ts`) acabava importando a instância junto. Isso NÃO
// fechava sozinho o ciclo de `no-circular` — o laço real é
// rotas -> `component: () => import(Layout*.vue)` -> `@/store/layout` (ver
// AD-018) — mas ainda assim é o ponto certo para expor as listas de rota sem
// depender de `createRouter`.
//
// Fica FORA de `src/router/rotas/` de propósito: essa pasta é camada legada
// congelada por R12/G8 (.camada-legada-baseline.json, T20) — arquivo novo ali
// é sempre rejeitado pelo gate `scripts/gate-camada-legada.mjs`, mesmo sendo
// um agregador sem lógica própria.
import rotasFabricacao from "@/views/Fabricacao/fabricacaoRotas";
import { rotaPedidoPublico } from "./rotas/ContratosAutomacao";
import { rotasAuth } from "./rotas/Auth";
import { rotasErro, rotaCatchAll } from "./rotas/Erro";
import { rotaChecklist } from "@/views/Produto/Checklist/checklistRotas";
import { rotaHome, rotasAbertasGeral, rotasRestritasGeral } from "./rotas/Geral";
import { rotaObraRestrita } from "@/views/Obra/obraRotas";

export const rotasAbertas = [
  ...rotaHome,
  ...rotasAuth,
  ...rotaChecklist,
  ...rotasErro,
  ...rotaPedidoPublico,
  ...rotaCatchAll,
  ...rotasAbertasGeral,
];

export const rotasRestritas = [...rotaObraRestrita, ...rotasFabricacao, ...rotasRestritasGeral];
